const mobileHeader = document.getElementById("methodme-theme-header-mobile");
if (mobileHeader) {
	const btn = document.querySelector(".mobile-menu-toggler");
	const offCanvas = document.querySelector(".off-canvas-menu");

	btn.addEventListener("click", toggleNav);

	function toggleNav(e) {
		e.preventDefault();
		offCanvas.classList.toggle("opened");
		if (offCanvas.classList.contains("opened")) {
			btn.setAttribute("aria-expanded", true);
			document.body.style.overflow = "hidden";
		} else {
			btn.setAttribute("aria-expanded", false);
			document.body.style.overflow = "auto";
		}
	}

	/**
	 *  Append Search form and Buttons to Mobile Header
	 */
	const mobileActions = mobileHeader.querySelector(".header-actions");
	const lastMainMobileMenuItem = mobileHeader.querySelector(".methodme-mobile-menu > li:last-child");
	lastMainMobileMenuItem.parentElement.appendChild(mobileActions);
}
